export const environment = {
    production: true,
    API_ENDPOINT: "https://app.smartdukaan.com/apis/",
    ONLINE_ORDER_ENDPOINT: "https://images.smartdukaan.com/orders/add",
    APP_URL: "app.smartdukaan.com",
    GA_TRACKING_ID: 'G-XTFQ1BWVN6'
};
